"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { CasesCardCarouselProps } from "./types";
import CasesCard from "../CasesCard";
import Link from "next/link";
import Icon from "@/components/ui/Icon";
import { Button } from "@/components/ui/button";

const CasesCardCarousel = ({
  className,
  exploreText = "Explore all use cases",
  cards,
}: CasesCardCarouselProps) => {
  return (
    <>
      <Carousel.Mobile
        options={{
          slides: {
            spacing: 24,
            perView: "auto",
          },
        }}
        showNavigation
        className={cn(
          "md:!grid md:!grid-cols-2 md:!gap-4 lg:!grid-cols-4 !overflow-visible [&>[data-carousel-slide]:not(.carousel-slide-active)]:opacity-50",
          className
        )}
        navigationSlot={
          <Link
            href="/use-cases"
            className="flex-auto py-3 pl-8 pr-4.5 flex items-center gap-4 min-w-0 border border-blue-500 text-[#2F80ED] text-base leading-[150%] font-semibold md:hidden rounded-3xl"
          >
            <span className="truncate flex-auto min-w-0">{exploreText}</span>
            <Icon
              id="icon-arrow-right-lg_24"
              width={24}
              height={24}
              className="shrink-0 w-6 h-6"
            />
          </Link>
        }
      >
        {cards.map(({ title, description, linkLabel, imageUrl, link }, i) => {
          return (
            <CarouselSlide
              key={i}
              className="!min-w-[82%] !w-[82%] !md:min-w-auto !w-auto transition-opacity duration-300 will-change-[opacity] md:transition-none md:!opacity-100 md:duration-initial"
            >
              <CasesCard
                title={title}
                imageUrl={imageUrl}
                description={description}
                link={link}
                linkLabel={linkLabel}
              />
            </CarouselSlide>
          );
        })}
      </Carousel.Mobile>
      <div className="hidden mt-12 text-center md:flex items-center justify-center">
        <Button
          asChild
          variant="primary-outline"
          className="py-3 px-6 h-[48px] w-full sm:w-auto"
        >
          <Link href="/use-cases" className="!text-base">
            {exploreText}
          </Link>
        </Button>
      </div>
    </>
  );
};

export default memo(CasesCardCarousel);
